<template>
  <div class="home">
    <WidgetsStrip />
    <h1 v-text="getWelcomeText"></h1>
    <div v-if="getPendingLabels && getPendingLabels.length > 0">
      <br />
      <p>Pending label versions for approval.</p>
      <filter-and-sort-box
        style="max-width: 940px;"
        :data="getPendingLabels"
        :headers="headers"
        :useSearch="false"
      >
        <template v-slot:d="{ d }">
          <td
            class="relative py-1"
            v-for="(key, index) in getKeys(d)"
            :key="key + index"
          >
            <div
              class="w-full py-4 bg-primary-light"
              :class="index === 0 ? 'pl-4' : 'pl-1'"
            >
              <span class="inline-block w-10/12">{{
                d[key] ? d[key] : ""
              }}</span>
            </div>
          </td>
          <td class="py-1">
            <div x class="flex justify-end pr-4 rounded-r bg-primary-light">
              <router-link
                :to="getLabelLink(d)"
                class="py-4 font-bold underline text-highlight"
                >{{ getStateAction(d) }}</router-link
              >
            </div>
          </td>
        </template>
      </filter-and-sort-box>
    </div>

    <AuthorizationZone
      allowAny="AccountType:Administrator,UserRole:GroupManager"
    >
      <div class="flex flex-wrap w-full mt-4">
        <p class="block w-full">Set up users and groups.</p>
        <AuthorizationZone allowAny="AccountType:Administrator">
          <router-link
            class="flex flex-col items-center justify-center w-20 p-4 text-white no-underline border border-white border-solid rounded-lg bg-primary hover:shadow-lg hover:bg-primary-dark"
            to="users"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-10 h-10"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            <h3 class="m-0 mt-2 font-light no-underline">Users</h3></router-link
          >
        </AuthorizationZone>
        <AuthorizationZone
          allowAny="AccountType:Administrator,UserRole:GroupManager"
        >
          <router-link
            to="groups"
            class="flex flex-col items-center justify-center w-20 p-4 ml-4 text-white no-underline border border-white border-solid rounded-lg bg-primary hover:shadow-xl hover:bg-primary-dark"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-10 h-10"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            <h3 class="m-0 mt-2 font-light no-underline">Groups</h3>
          </router-link>
        </AuthorizationZone>
      </div>
    </AuthorizationZone>

    <AuthorizationZone
      allowAny="AccountType:Administrator,UserRole:LabelManager,UserRole:OrderManager,UserRole:ArticleManager,UserRole:PrinterManager"
    >
      <div class="flex flex-wrap w-full mt-4">
        <p class="block w-full">Set up labels. articles and orders.</p>
        <AuthorizationZone
          allowAny="AccountType:Administrator,UserRole:LabelManager"
        >
          <router-link
            class="flex flex-col items-center justify-center w-20 p-4 text-white no-underline border border-white border-solid rounded-lg bg-primary hover:shadow-lg hover:bg-primary-dark"
            to="labels"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-10 h-10"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <h3 class="m-0 mt-2 font-light no-underline">Labels</h3>
          </router-link>
        </AuthorizationZone>
        <AuthorizationZone
          allowAny="AccountType:Administrator,UserRole:ArticleManager"
        >
          <router-link
            class="flex flex-col items-center justify-center w-20 p-4 text-white no-underline border border-white border-solid rounded-lg bg-primary hover:shadow-lg hover:bg-primary-dark"
            to="articles"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-10 h-10"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
                d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
              />
            </svg>
            <h3 class="m-0 mt-2 font-light no-underline">Articles</h3>
          </router-link>
        </AuthorizationZone>
        <AuthorizationZone
          allowAny="AccountType:Administrator,UserRole:OrderManager"
        >
          <router-link
            class="flex flex-col items-center justify-center w-20 p-4 text-white no-underline border border-white border-solid rounded-lg bg-primary hover:shadow-lg hover:bg-primary-dark"
            to="orders"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-10 h-10"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
                d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"
              />
            </svg>
            <h3 class="m-0 mt-2 font-light no-underline">Orders</h3>
          </router-link>
        </AuthorizationZone>

        <FeatureZone features="pdfOnly" :inverted="true">
          <AuthorizationZone
            allowAny="AccountType:Administrator,UserRole:PrinterManager"
          >
            <router-link
              class="flex flex-col items-center justify-center w-20 p-4 text-white no-underline border border-white border-solid rounded-lg bg-primary hover:shadow-lg hover:bg-primary-dark"
              to="printers"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-10 h-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                  d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
                />
              </svg>
              <h3 class="m-0 mt-2 font-light no-underline">Printers</h3>
            </router-link>
          </AuthorizationZone>
        </FeatureZone>
      </div>
    </AuthorizationZone>
    <div class="flex flex-wrap w-full mt-4">
      <p class="block w-full">
        Print labels
      </p>
      <router-link
        v-if="
          features.showFeatures && features.showFeatures.myLabels.showMyLabels
        "
        class="flex flex-col items-center justify-center w-20 p-4 text-white no-underline border border-white border-solid rounded-lg bg-primary hover:shadow-lg hover:bg-primary-dark"
        to="/print-labels"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-10 h-10"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        <h3 class="m-0 mt-2 font-light no-underline">My Labels</h3></router-link
      >
      <router-link
        v-if="features.showFeatures && features.showFeatures.showMyArticles"
        class="flex flex-col items-center justify-center w-20 p-4 text-white no-underline border border-white border-solid rounded-lg bg-primary hover:shadow-lg hover:bg-primary-dark"
        to="/print-articles"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-10 h-10"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1"
            d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
          />
        </svg>
        <h3 class="m-0 mt-2 font-light no-underline">
          My Articles
        </h3>
      </router-link>
      <router-link
        v-if="features.showFeatures && features.showFeatures.showMyOrders"
        class="flex flex-col items-center justify-center w-20 p-4 text-white no-underline border border-white border-solid rounded-lg bg-primary hover:shadow-lg hover:bg-primary-dark"
        to="/myorders"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-10 h-10"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1"
            d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"
          />
        </svg>
        <h3 class="m-0 mt-2 font-light no-underline">My Orders</h3></router-link
      >
      <br />
      <br />
      <div class="flex flex-wrap w-full mt-4">
        <FeatureZone features="labelVersionControlEnabled">
          <p v-if="userIsLabelDesigner">Access labels</p>
          <AuthorizationZone allowAny="QualityAssuranceRole:LabelDesigner">
            <router-link
              class="flex flex-col items-center justify-center w-20 p-4 text-white no-underline border border-white border-solid rounded-lg bg-primary hover:shadow-lg hover:bg-primary-dark"
              to="/qa/labels"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-10 h-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <h3 class="m-0 mt-2 font-light no-underline">Labels</h3>
            </router-link>
          </AuthorizationZone>
        </FeatureZone>
      </div>
    </div>
    <div class="flex flex-wrap w-full mt-4">
      <FeatureZone features="importEnabled">
        <p v-if="userCanImport">Import articles and orders.</p>
        <AuthorizationZone allowAny="UserRole:DataImporter">
          <div class="flex flex-wrap">
            <router-link
              to="importdata"
              class="flex flex-col items-center justify-center w-20 p-4 text-white no-underline border border-white border-solid rounded-lg bg-primary hover:shadow-lg hover:bg-primary-dark"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-10 h-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                />
              </svg>
              <h3 class="m-0 mt-2 font-light no-underline">
                Import file
              </h3>
            </router-link>
            <router-link
              to="importhistory"
              class="flex flex-col items-center justify-center w-20 p-4 text-white no-underline border border-white border-solid rounded-lg bg-primary hover:shadow-lg hover:bg-primary-dark"
            >
              <div class="relative">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-10 h-10"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="absolute top-0 right-0 w-5 h-5 -mt-2 -mr-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
              </div>
              <h3 class="m-0 mt-2 font-light no-underline">
                History
              </h3>
            </router-link>
          </div>
        </AuthorizationZone>
      </FeatureZone>
    </div>

    <FeatureZone features="importEnabled" :inverted="true">
      <import-data v-if="userCanImport" />
    </FeatureZone>
  </div>
</template>

<script>
import ImportData from "../components/ImportData";
import FeatureZone from "../components/FeatureZone";
import AuthorizationZone from "../components/AuthorizationZone";
import FilterAndSortBox from "../components/FilterAndSortBox";
import WidgetsStrip from "@/components/widgets/WidgetsStrip.vue";

export default {
  components: {
    ImportData,
    FeatureZone,
    AuthorizationZone,
    FilterAndSortBox,
    WidgetsStrip,
  },
  data: () => ({
    features: {},
    importEnabled: false,
    headers: {
      versionId: "Pending version",
      name: "Label name",
    },
  }),
  methods: {
    async getData() {
      await this.getEnabledFeatures();
      const user = this.$store.getters["AUTH/AUTH_GET_USER"];
      if (
        user &&
        user.QualityAssuranceRole &&
        user.QualityAssuranceRole.length > 0
      )
        await this.$store.dispatch("QUALITY_ASSURANCE/GET_PENDING");
    },
    async getEnabledFeatures() {
      const response = await this.$store.$api.get("/api/features");
      this.features = response.data.data;
      this.importEnabled = this.features.importEnabled;
    },
    getKeys(labelVersion) {
      return Object.keys(labelVersion).filter(key => {
        return key === "name" || key === "labelVersionId";
      });
    },
    getStateAction(labelVersion) {
      switch (labelVersion.state) {
        case "Publisher":
          return "Review Publish";
        case "DataApprover":
          return "Review Data";
        case "DesignApprover":
          return "Review Design";
        default:
          return "Preview";
      }
    },
    getLabelLink(labelVersion) {
      switch (labelVersion.state) {
        case "Publisher":
          return `/qa/labels/${labelVersion.labelId}/versions/${
            labelVersion.labelVersionId
          }/publish`;

        case "DataApprover":
          return `/qa/labels/${labelVersion.labelId}/versions/${
            labelVersion.labelVersionId
          }/approve`;
        case "DesignApprover":
          return `/qa/labels/${labelVersion.labelId}/versions/${
            labelVersion.labelVersionId
          }/approve`;
        default:
          return `/qa/labels/${labelVersion.labelId}/versions/${
            labelVersion.labelVersionId
          }/preview`;
      }
    },
  },
  computed: {
    getWelcomeText() {
      const user = this.$store.getters["AUTH/AUTH_GET_USER"];

      if (user === undefined) return "";

      return "Welcome " + user.firstname + "!";
    },
    userIsLabelDesigner() {
      const user = this.$store.getters["AUTH/AUTH_GET_USER"];

      if (this.features.labelVersionControlEnabled === true) {
        return user.QualityAssuranceRole &&
          user.QualityAssuranceRole.includes("LabelDesigner")
          ? true
          : false;
      }
      return false;
    },
    userCanImport() {
      const user = this.$store.getters["AUTH/AUTH_GET_USER"];
      return user.UserPermission &&
        user.UserPermission.includes("DataImporter") &&
        this.importEnabled
        ? true
        : false;
    },
    getPendingLabels() {
      return this.$store.getters["QUALITY_ASSURANCE/PENDING"];
    },
  },
  async mounted() {
    await this.getData();
  },
};
</script>
